import ImageWithBasePath from "@/components/image-with-base-path"

import Slider, { type Settings } from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CompanySection = () => {
    const settings: Settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0, // optional (see note below)
    arrows: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
   <>
  {/* Start Company Section */}
  <div className="section company-section-fifteen pb-0">
    <div className="container">
      <div
        className="section-header-fifteen text-center wow fadeInUp"
        data-wow-duration="2s"
      >
        <div className="sub-title">Trusted By 5k+ Clients around the World</div>
      </div>
      <div className="container">
        <ImageWithBasePath
          src="assets/img/bg/shadow-1.png"
          alt="shadow"
          className="shadow-1"
        />
        <ImageWithBasePath
          src="assets/img/bg/shadow-2.png"
          alt="shadow"
          className="shadow-2"
        />
        <div
          className="company-slider company-slider-fifteen wow fadeInUp"
          data-wow-duration="2s"
        >
          <Slider {...settings}>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-1.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-2.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-3.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-4.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-5.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-6.svg" alt="img" />
          </div>
          <div className="slide-item">
            <ImageWithBasePath src="assets/img/company/company-img-4.svg" alt="img" />
          </div>
          </Slider>
        </div>
      </div>
    </div>
  </div>
  {/* End Company Section */}
</>

  )
}

export default CompanySection